import React from "react";
import { Link } from "react-router-dom";

import { albumPath } from "../../api/albums";

import "../Album/Album.scss";

type ListenedAlbumProps = {
    albumId: number;
    title: string;
    artistName: string;
    coverUrl: string | null;
    recommenderLabel: string;
    listenedDateLabel: string;
};

export function ListenedAlbum({
    albumId,
    title,
    artistName,
    coverUrl,
    recommenderLabel,
    listenedDateLabel,
}: ListenedAlbumProps) {
    return (
        <Link className="album" to={albumPath(albumId)}>
            {coverUrl ? (
                <img src={coverUrl} alt={title} />
            ) : (
                <div className="album__cover-placeholder" aria-hidden />
            )}
            <div className="details">
                <p>
                    <b>{title}</b>
                    <br />
                    <span className="artist">{artistName}</span>
                </p>
                <span className="recommender">{recommenderLabel}</span>
                <span className="listened-date">{listenedDateLabel}</span>
            </div>
        </Link>
    );
}
